import { COLORS } from '../styles/tokens';

// Statusbrikker for bestillerens oppdrag
export const STATUS_LABEL = {
  draft:             { text: 'Utkast',          bg: COLORS.surfaceHover, color: COLORS.textLight,   border: COLORS.border },
  open:              { text: 'Åpen',            bg: COLORS.blueBg,       color: COLORS.blueText,    border: COLORS.blue },
  matched:           { text: 'Tildelt',         bg: COLORS.purpleBg,     color: COLORS.purpleText,  border: COLORS.purple },
  in_progress:       { text: 'Under transport', bg: COLORS.warningBg,    color: COLORS.warningText, border: COLORS.warning },
  delivered_pending: { text: 'Venter',          bg: COLORS.purpleBg,     color: COLORS.purpleText,  border: COLORS.purple },
  completed:         { text: 'Fullført',        bg: COLORS.successBg,    color: COLORS.successText, border: COLORS.success },
  invoiced:          { text: 'Fakturert',       bg: COLORS.successBg,    color: COLORS.successText, border: COLORS.success },
  refunded:          { text: 'Refundert',       bg: COLORS.surfaceHover, color: COLORS.textMid,     border: COLORS.border },
  cancelled:         { text: 'Kansellert',      bg: COLORS.surfaceHover, color: COLORS.textLight,   border: COLORS.border },
  disputed:          { text: 'Tvist',           bg: COLORS.dangerBg,     color: COLORS.dangerText,  border: COLORS.danger },
};

export function statusInfo(status) {
  return STATUS_LABEL[status] ?? { text: status, bg: COLORS.surfaceHover, color: COLORS.textLight, border: COLORS.border };
}
